import styled from 'styled-components';
import { Select, Datepicker } from 'components';

export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const FilterInput = styled.input`
  flex: 1 1 0%;
  font-size: 12px !important;
  padding: 2px 4px;
  width: 100%;
  &::placeholder {
    font-size: 12px !important;
  }
  &::-webkit-input-placeholder {
    font-size: 12px !important;
  }
  &::-moz-placeholder {
    font-size: 12px !important;
  }
  &:-ms-input-placeholder {
    font-size: 12px !important;
  }
  &::-ms-input-placeholder {
    font-size: 12px !important;
  }
`;

export const FilterSelect = styled(Select)`
  flex: 1 1 0%;
  width: 100%;
`;

export const FilterDatepicker = styled(Datepicker)`
  flex: 1 1 0%;
  width: 100%;
`;

export const FilterButton = {
  flex: '0 0 auto',
  marginLeft: 4,
};

export const DateRange = styled.div`
  background: ${({ theme }) => theme?.colors?.tertiary || '#fff'};
  border: 1px solid ${({ theme }) => theme?.colors?.border || '#ddd'};
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 100;
  position: absolute;
  min-width: 15rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  padding: 1rem;
  top: 2.5rem;
  left: 0;
`;

export const DateRangeButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: ${({ theme }) => theme?.colors?.gray[500]}; 
  height: 40px;
  padding: 4px 10px;
  border: 1px solid ${({ theme }) => theme?.colors?.border || '#ddd'};
  background: ${({ theme }) => theme?.colors?.background || '#fff'};
  cursor: pointer;
  font-size: 12px;
  width: 100%;
  &:hover {
    background: ${({ theme }) => theme?.colors?.hover || '#f5f5f5'};
  }
`;